define(["bluebird","jquery"], function(__WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__43__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 162);
/******/ })
/************************************************************************/
/******/ ({

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(163);


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClientCenterCustomerService", {
  enumerable: true,
  get: function get() {
    return _index.ClientCenterCustomerService;
  }
});

var _index = __webpack_require__(164);

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientCenterCustomerService = void 0;

var _jquery = _interopRequireDefault(__webpack_require__(43));

var _bluebird = _interopRequireDefault(__webpack_require__(17));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Client Center  Customer Service relevant for Customer Related Operations like fetch and manage
 * @param {String} ccBaseUrl - represents base url for client center site
 * @param {Object} ccJsData - JsData object for caching response
 * @param {function} getUserPreferences() - asynchronous Ajax funtion to get a user's preferences
 * @param {function} setUserPreferences() - asynchronous Ajax funtion to set a user's preferences
 * @param {function} getCustomers() - asynchronous Ajax funtion to get Customers under a Person
 * @param {function} getRecentAccesssEntities() - asynchronous Ajax funtion to get recently accessed
 * entities under a customer
 * @param {function} getCustomerHierarchy() - asynchronous Ajax funtion to get linked
 * accounts and customers for a given customer id
 * return Promise for the corresponding API response
 * @param {function} getAccount() - asynchronous Ajax funtion to get Account
 */
class ClientCenterCustomerService {
  constructor({
    ccBaseUrl,
    ccJsData
  }) {
    this.baseCustomerUrl = ccBaseUrl;
    this.ccJsData = ccJsData;
  }

  getUserPreferences({
    uid,
    id
  }) {
    if (this.ccJsData) {
      return this.ccJsData.UserPreference.findAll({
        uid,
        id
      });
    }

    const url = this.baseCustomerUrl.concat('/Api/Preference/UserPreference');
    return _bluebird.default.resolve(_jquery.default.ajax({
      url,
      data: {
        uid,
        id
      },
      xhrFields: {
        withCredentials: true
      }
    }));
  }

  setUserPreferences({
    data,
    uid,
    id
  }) {
    const url = this.baseCustomerUrl.concat('/Api/Preference/UserPreference');
    return new _bluebird.default((resolve, reject) => {
      _jquery.default.ajax({
        url,
        data: {
          data,
          uid,
          id
        },
        xhrFields: {
          withCredentials: true
        },
        type: 'POST',
        success: response => resolve(response),
        error: (xhr, status) => reject(status)
      });
    });
  } // ToDO: Task 1460962: Add Test Case for the ClientCenterCustomerService Shared Component


  getCustomers() {
    const getCustomersListUrl = this.baseCustomerUrl.concat('/Customers/GetCustomers'); //  $.getJSON throws parse error for Cross Domain Requests. using $.ajax with xhrFields
    //  checks for authorization before making the call and allows cross domain requests

    return _bluebird.default.resolve(_jquery.default.ajax({
      url: getCustomersListUrl,
      data: {
        rurl: window.location.href
      },
      xhrFields: {
        withCredentials: true
      }
    }));
  }

  getRecentAccesssEntities({
    cid,
    uid,
    limit = null
  }) {
    const getRecentAccesssEntitiesUrl = this.baseCustomerUrl.concat('/Customers/RecentAccessedEntities');
    return _bluebird.default.resolve(_jquery.default.ajax({
      url: getRecentAccesssEntitiesUrl,
      data: {
        cid,
        uid,
        limit,
        rurl: window.location.href
      },
      xhrFields: {
        withCredentials: true
      }
    }));
  }

  getCustomerHierarchy({
    cid,
    uid,
    searchTerm = null,
    start = null,
    limit = null,
    returnOnlyDirectlyLinkedEntities = true
  }) {
    const options = {
      cid,
      uid,
      targetCid: cid,
      searchTerm,
      start,
      limit,
      returnOnlyDirectlyLinkedEntities,
      rurl: window.location.href
    };

    if (this.ccJsData) {
      return this.ccJsData.CustomerHierarchy.find(cid, {
        params: options,
        bypassCache: true
      });
    }

    const getCustomerHierarchyUrl = this.baseCustomerUrl.concat('/Customers/SearchCustomerHierarchy');
    return _bluebird.default.resolve(_jquery.default.ajax({
      url: getCustomerHierarchyUrl,
      data: options,
      xhrFields: {
        withCredentials: true
      }
    }));
  }

  getAncestorHierarchyPath({
    cid,
    uid,
    entityId,
    isCustomer
  }) {
    const options = {
      cid,
      uid,
      targetCid: cid,
      entityId,
      isCustomer
    };

    if (this.ccJsData) {
      return this.ccJsData.AncestorHierarchyPath.find(`${entityId}_${cid}`, {
        params: options,
        bypassCache: true
      });
    }

    const getAncestorHierarchyPathUrl = this.baseCustomerUrl.concat('/Customers/AncestorHierarchyPath');
    return _bluebird.default.resolve(_jquery.default.ajax({
      url: getAncestorHierarchyPathUrl,
      data: options,
      xhrFields: {
        withCredentials: true
      }
    }));
  }

  getAccount({
    uid,
    id,
    cid
  }) {
    const url = this.baseCustomerUrl.concat('/ApI/Account');
    return _bluebird.default.resolve(_jquery.default.ajax({
      url,
      data: {
        uid,
        id,
        cid
      },
      xhrFields: {
        withCredentials: true
      }
    }));
  }

}

exports.ClientCenterCustomerService = ClientCenterCustomerService;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__43__;

/***/ })

/******/ })});;
